import React, { ChangeEvent, FC, useEffect, useRef, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import uniqueId from 'lodash/uniqueId'

import { ReactComponent as Close } from 'sources/images/close.svg'

import styles from './styles.module.scss'

interface IProps {
  onChange: (value: ITag[]) => void
  tags: ITag[]
}

interface ITag {
  tag: string,
  id: string,
  correct: boolean
}

export const Tags: FC<IProps> = ({ onChange, tags }) => {

  const [inputValue, setInputValue] = useState<string>('')
  const inputRef = useRef<HTMLInputElement | null>(null)
  let timerFocusOnInput!: NodeJS.Timeout

  const setFocusOnEmailInput = () => {
    timerFocusOnInput = setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus()
      }
    }, 100)
  }

  const keyboardEvents = (event: React.KeyboardEvent<HTMLInputElement>) => {
    event.persist()
    if ((event.key === 'Enter' || event.code === 'Enter') || event.key === 'Space' || event.code === 'Space') {
      if (inputValue.length === 0) return

      const id = uniqueId()
      const tag = inputValue.charAt(0) === '#' ? inputValue.slice(1, inputValue.length) : inputValue

      if (tag.match(/[^a-zA-Z]+/g)) {
        onChange(tags.filter(item => item.tag !== inputValue).concat([{ tag: inputValue, id, correct: false }]))
      } else {
        // Correct
        onChange(tags.filter(item => item.tag !== tag).concat([{ tag: tag, id, correct: true }]))
      }
      setInputValue('')
    }
  }

  const onChangeTag = (e: ChangeEvent<HTMLInputElement>) => {
    if (inputValue.length === 0 && Boolean(e.target.value.match(/\s/))) {
      setInputValue('')
    } else {
      setInputValue(e.target.value)
    }
  }

  const onDeleteTag = (id: string) => {
    onChange(tags.filter(item => item.id !== id))
    setFocusOnEmailInput()
  }

  return (
    <div onClick={setFocusOnEmailInput} className={styles.tagsContainer}>
      {tags.map((item) => (
        <div key={item.id}
             className={cn({
               [styles.tagBlock]: true,
               [styles.tagBlockError]: !item.correct
             })}>
          {item.tag}
          <Close className={styles.deleteTag} onClick={() => onDeleteTag(item.id)}/>
        </div>
      ))}

      <div className={cn({
        [styles.inputWrapper]: true
      })}>
        <input placeholder={'Tag'}
               className={cn({
                 [styles.tagInput]: true
               })}
               value={inputValue}
               onChange={onChangeTag}
               onKeyDown={e => keyboardEvents(e)}
               ref={inputRef}
        />
      </div>
    </div>
  )
}
